import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Header from '../../common/Header';
import PageContentPanel from '../panels/PageContentPanel';
import { DashboardTimelineType, OwnerType } from '../../../constants/ComponentTypes';

const styles = () => ({
  root: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    overflowY: 'auto',
  },
});

class OrderDashboardTimelineStatusType extends React.Component {
  initialState = {
    ownerType: OwnerType.OWN.value,
  }

  constructor(props) {
    super(props);
    const ownerType = props.location.state && props.location.state.ownerType ? props.location.state.ownerType : OwnerType.OWN.value;
    this.state = { ...this.initialState, ...{ ownerType: ownerType } };
  }

  componentDidMount() {
    this.props.getUserInfo(true);
  }

  render() {
    const { classes, type } = this.props;

    const target = Object.values(DashboardTimelineType).find(item => item.value === type);

    return (
      <div className={classes.root}>
        <Header
          title="ダッシュボード"
          secondaryTitle={target.text}
          type="dark"
          hasBackBtn={false}
          onTitleClicked={() => this.props.goTo('/order-dashboard', {
            ownerType: this.state.ownerType
          })}
        />
        <PageContentPanel
          type={target.value}
          items={this.props.list}
          goTo={this.props.goTo}
          isLoading={this.props.isLoading}
          pageInfo={this.props.pageInfo}
          ownerType={this.state.ownerType}
          getStatus={this.props.getCurrentPersonStatus}
        />
      </div>
    )
  }
}

OrderDashboardTimelineStatusType.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  pageInfo: PropTypes.object,
  getCurrentPersonStatus: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  goTo: PropTypes.func.isRequired,
  user: PropTypes.object,
  list: PropTypes.array,
  location: PropTypes.object,
};

export default withStyles(styles)(OrderDashboardTimelineStatusType);



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/pages/OrderDashboardTimelineStatusType.jsx